{
    "Profile_CommonComponents_DiscountBadges.discounts": " FR: Discounts ",
    "Profile_CommonComponents_DiscountBadges.DISCF.label1": "FR: Conviction",
    "Profile_CommonComponents_DiscountBadges.DISCF.label2": "FR: Free",
    "Profile_CommonComponents_DiscountBadges.DISMP.label1": "FR: Multi",
    "Profile_CommonComponents_DiscountBadges.DISMP.label2": "FR: Line",
    "Profile_CommonComponents_DiscountBadges.DISMV.label1": "FR: Multi",
    "Profile_CommonComponents_DiscountBadges.DISMV.label2": "FR: Vehicle",
    "Profile_CommonComponents_DiscountBadges.DISNB.label1": "FR: New",
    "Profile_CommonComponents_DiscountBadges.DISNB.label2": "FR: Customer",
    "Profile_CommonComponents_DiscountBadges.DISNC.label1": "FR: No",
    "Profile_CommonComponents_DiscountBadges.DISNC.label2": "FR: Claims",
    "Profile_CommonComponents_DiscountBadges.DISSN.label1": "FR: Winter",
    "Profile_CommonComponents_DiscountBadges.DISSN.label2": "FR: Tires",
    "Profile_CommonComponents_DiscountBadges.ZDSAB.label1": "FR: Autonomous",
    "Profile_CommonComponents_DiscountBadges.ZDSAB.label2": "FR: Braking",
    "Profile_CommonComponents_DiscountBadges.GENERIC.label1": "FR: Carrier",
    "Profile_CommonComponents_DiscountBadges.GENERIC.label2": "FR: Discount"
}
